import { CustomAppLayout } from '../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect, useState } from 'react';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useRouter } from '../router';
//import { useStore } from '../store';
import Flashbar from '@cloudscape-design/components/flashbar';
import { useGlobalState } from '../../context/GlobalStateContext'


import { useStore } from '../store';
import { useStoreAdmin } from '../../context/useStoreAdmin';

import Board, { BoardProps } from "@cloudscape-design/board-components/board";
import BoardItem from "@cloudscape-design/board-components/board-item";
import Header from "@cloudscape-design/components/header";
import { Badge, Box, Button, Cards, FlashbarProps, FormField, Input, KeyValuePairs, Link, Pagination, PieChart, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import { mdiBoomGateArrowUpOutline, mdiCalendarOutline, mdiCheckCircleOutline, mdiCloseCircleOutline, mdiDeleteClockOutline, mdiEmailOpenOutline, mdiHelpCircleOutline, mdiLockOpenOutline, mdiLockOutline, mdiRefresh, mdiTimerEditOutline, mdiTimerPlusOutline, mdiTimerSandEmpty } from '@mdi/js';
import { date } from 'zod';
import { Icon } from '@mdi/react';


const pageSize = 20;
interface Access {
    idAcceso: number;
    isActive: number;
    isMantAcceso: number;
    relay: number;
    acceso: string;
    isOnline: number;
    manualOpenEnable: number;
    idSector: number;
    sector: string;
    label: string;
    id: string;
    description?: string
    disabled?: boolean;
}
interface MyBoardItemData {
    title: string;
    description?: string;
    content: React.ReactNode;
    footer?: React.ReactNode;
    actions?: React.ReactNode;
}
type LogItem = { idLog: number; fecha: string; hora: string; status: string; log: string; user: string; objTime: string; };
interface Sector { idSector: number; sector: string; }

export const HomePage = () => {
    const storeAdmin = useStoreAdmin();

    const { JWT, setJWT } = useGlobalState();
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const { setLoading } = useGlobalState();
    const [logs, setLogs] = useState<LogItem[]>([]);
    const [accesses, setAccesses] = useState<Access[]>([]);
    const [servers, setServers] = useState<any[]>([]);

    const [pendingGuests, setPendingGuests] = React.useState(0)
    const [pendingAuth, setPendingAuth] = React.useState(0)
    const [users, setUsers] = React.useState(0)
    const [invoicesActive, setInvoicesActive] = React.useState(0)
    const [invoicesDebt, setInvoicesDebt] = React.useState(0)
    const [invoicesExpired, setInvoicesExpired] = React.useState(0)
    const [invoicesExpiredDebt, setInvoicesExpiredDebt] = React.useState(0)
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const getBoardItems = (): BoardProps.Item<any>[] => {
        const items: (BoardProps.Item<any> | false)[] = [];
        items.push({
            id: "1",
            rowSpan: 6,
            columnSpan: 1,
            data: {
                title: "Accesos", description: "Estado de los accesos",
                setting: "TEST2",
                content: (<Cards
                    cardDefinition={{
                        header: item => (
                            <span>
                                <Link href="#" fontSize="heading-m">
                                    {item.acceso}
                                </Link>
                            </span>
                        ),
                        sections: [
                            {
                                id: "type",
                                header: "Conexión",
                                content: item => (
                                    <span>
                                        {item.relay === 0 ? (
                                            <Badge color="blue">VIRTUAL</Badge>
                                        ) : item.isOnline === 1 ? (
                                            <Badge color="green">ONLINE</Badge>
                                        ) : (
                                            <Badge color="grey">OFFLINE</Badge>
                                        )}
                                    </span>
                                ),
                                width: 50
                            },
                            {
                                id: "size",
                                header: "Estado",
                                content: item => (
                                    <span>
                                        {item.isActive === 0 ? (
                                            <Badge color="grey">INACTIVO</Badge>
                                        ) : item.isMantAcceso === 1 ? (
                                            <Badge color="severity-medium">MANTENIMIENTO</Badge>
                                        ) : (
                                            <Badge color="green">ACTIVO</Badge>
                                        )}
                                    </span>
                                ),
                                width: 50

                            }
                        ],
                    }}
                    cardsPerRow={
                        [
                            { cards: 1 },
                        ]}

                    items={accesses}
                ></Cards >
                )

            }
        })
        items.push({
            id: "2",
            rowSpan: 1,
            columnSpan: 3,
            data: {
                title: "Servicios pendientes",
                description: "Contadores de actividades pendientes",
                actions: (
                    <Link variant="info" onClick={handleRefresh}><Icon path={mdiRefresh} size={1}></Icon></Link>
                ),
                content: (
                    <KeyValuePairs
                        columns={6}
                        items={[
                            {
                                label: "Autorizaciones",
                                value: <Link><h1>{pendingAuth}</h1></Link>,
                            },
                            {
                                label: "Invitaciones",
                                value: <Link><h1>{pendingGuests}</h1></Link>,
                            },
                            {
                                label: "Usuarios",
                                value: <Link><h1>{users}</h1></Link>,
                            },
                            {
                                label: "Facturación",
                                info: invoicesExpired > 0 ? `${invoicesExpired} item${invoicesExpired > 1 ? "s" : ""}` : "",
                                value: (
                                    <h1>
                                        {invoicesExpiredDebt > 0 ? (
                                            <span style={{ color: 'red' }}>{
                                                new Intl.NumberFormat('es-CL', {
                                                    style: 'currency',
                                                    currency: 'CLP',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                }).format(invoicesExpiredDebt)

                                            }</span>
                                        ) : (
                                            'Sin deuda'
                                        )}
                                    </h1>
                                )
                            },
                        ]}
                    />
                )
            },
        })
        items.push({
            id: "3",
            rowSpan: 4,
            columnSpan: 3,
            columnOffset: { 4: 1 },
            data: {
                title: "Eventos",
                footer: (<Box textAlign="center"><Link href='#logs/all'>Ver bitácora</Link></Box>),
                description: "Últimos 10 registros en bitácora",
                content: (

                    <Table
                        stripedRows
                        wrapLines
                        stickyHeader
                        renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) => `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`}
                        //onSelectionChange={handleSelectionChange}

                        columnDefinitions={[
                            {
                                id: "hora",
                                header: "Hora",
                                cell: (item) => item.hora,
                                sortingField: "objTime",
                                isRowHeader: true,
                                width: 110,
                            },
                            {
                                id: "status",
                                header: "Categoría",
                                cell: (item) => {
                                    let statusText = '';
                                    let statusColor: "red" | "blue" | "grey" | "green" | "yellow" | "severity-critical" | "severity-high" | "severity-medium" | "severity-low" | "severity-neutral" | "" | undefined = "grey";
                                    let statusIcon = mdiHelpCircleOutline;


                                    if (item.status === 'OPEN.COMPLETE') {
                                        statusText = "Apertura";
                                        statusColor = 'green';
                                        statusIcon = mdiCheckCircleOutline
                                    } else if (item.status === 'OPEN.PENDING') {
                                        statusText = "Apertura";
                                        statusColor = 'severity-low';
                                        statusIcon = mdiTimerSandEmpty
                                    } else if (item.status === 'OPEN.BUSY') {
                                        statusText = "Apertura";
                                        statusColor = 'severity-high';
                                        statusIcon = mdiCloseCircleOutline
                                    } else if (item.status === 'MANUAL.OPEN') {
                                        statusText = "Manual";
                                        statusColor = "blue";
                                        statusIcon = mdiBoomGateArrowUpOutline;
                                    } else if (item.status === 'ACCESS.BLOCK') {
                                        statusText = "Acceso";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOutline
                                    } else if (item.status === 'ACCESS.UNBLOCK') {
                                        statusText = "Acceso";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOpenOutline
                                    } else if (item.status === 'UNIT.BLOCK') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOutline
                                    } else if (item.status === 'UNIT.UNBLOCK') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOpenOutline
                                    } else if (item.status === 'POLICY.ADD') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiTimerPlusOutline
                                    } else if (item.status === 'POLICY.DELETE') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiDeleteClockOutline
                                    } else if (item.status === 'POLICY.MOD') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiTimerEditOutline
                                    } else if (item.status === 'GUEST.ARRIVAL') {
                                        statusText = "Invitados";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiEmailOpenOutline
                                    } else {
                                        statusText = item.status; // Default to the item's status
                                        statusColor = 'grey'; // Or some other default color
                                    }

                                    return (
                                        <Box display="inline">
                                            <Badge color={statusColor}>
                                                {statusIcon && <Icon path={statusIcon} size={0.5} />} {statusText}
                                            </Badge>
                                        </Box>
                                    );
                                },
                                width: 150,
                            },
                            {
                                id: "log",
                                header: "Registro",
                                cell: item => (
                                    <div>
                                        <div style={{ fontWeight: "bold" }}>{item.user !== '' ? item.user : "SISTEMA"}</div>
                                        <div style={{ color: "#666", fontSize: "12px" }}>{item.log}</div>
                                    </div>
                                ),
                            },
                        ]}
                        items={logs}
                        //selectionType="multi"
                        trackBy="idLog"
                    ></Table>
                )
            }
        })

        if (servers && servers.length) {
            items.push({
                id: "4",
                rowSpan: 3,
                columnSpan: 4,
                data: {
                    title: "Disponibilidad",
                    description: "Estado de los servicios de operación",
                    content: (
                        <KeyValuePairs
                            columns={servers.length}
                            items={[
                                {
                                    label: `Sistema ${servers.find(s => s.id === 3238183)?.service}`,
                                    info: `${servers.find(s => s.id === 3238183)?.lastCheck}`,
                                    value: (
                                        <PieChart hideDescriptions hideFilter hideTitles fitHeight size={'small'}
                                            data={[
                                                {
                                                    title: "Disponible",
                                                    value: servers.find(s => s.id === 3238183)?.status.data.attributes.availability,
                                                },
                                                {
                                                    title: "Falla",
                                                    value: 100 - servers.find(s => s.id === 3238183)?.status.data.attributes.availability,
                                                },
                                            ]}
                                            segmentDescription={(datum, sum) =>
                                                `${datum.value} units, ${(
                                                    (datum.value / sum) *
                                                    100
                                                ).toFixed(2)}%`
                                            }
                                            ariaDescription="Pie chart showing how many resources are currently in which state."
                                            ariaLabel="Pie chart"
                                        />
                                    )
                                },
                                {
                                    label: `Sistema ${servers.find(s => s.id === 3238184)?.service}`,
                                    info: `${servers.find(s => s.id === 3238184)?.lastCheck}`,
                                    value: (
                                        <PieChart hideDescriptions hideFilter hideTitles fitHeight size={'small'}
                                            data={[
                                                {
                                                    title: "Disponible",
                                                    value: servers.find(s => s.id === 3238184)?.status.data.attributes.availability,
                                                },
                                                {
                                                    title: "Falla",
                                                    value: 100 - servers.find(s => s.id === 3238184)?.status.data.attributes.availability,
                                                },
                                            ]}
                                            segmentDescription={(datum, sum) =>
                                                `${datum.value} units, ${(
                                                    (datum.value / sum) *
                                                    100
                                                ).toFixed(2)}%`
                                            }
                                            ariaDescription="Pie chart showing how many resources are currently in which state."
                                            ariaLabel="Pie chart"
                                        />
                                    )
                                },
                                {
                                    label: `Sistema ${servers.find(s => s.id === 3238185)?.service}`,
                                    info: `${servers.find(s => s.id === 3238185)?.lastCheck}`,
                                    value: (
                                        <PieChart hideDescriptions hideFilter hideTitles fitHeight size={'small'}
                                            data={[
                                                {
                                                    title: "Disponible",
                                                    value: servers.find(s => s.id === 3238185)?.status.data.attributes.availability,
                                                },
                                                {
                                                    title: "Falla",
                                                    value: 100 - servers.find(s => s.id === 3238185)?.status.data.attributes.availability,
                                                },
                                            ]}
                                            segmentDescription={(datum, sum) =>
                                                `${datum.value} units, ${(
                                                    (datum.value / sum) *
                                                    100
                                                ).toFixed(2)}%`
                                            }
                                            ariaDescription="Pie chart showing how many resources are currently in which state."
                                            ariaLabel="Pie chart"
                                        />
                                    )
                                },
                            ]}
                        />
                    )
                },
            })
        }
        return items.filter(Boolean) as BoardProps.Item<any>[];
    }


    const handleRefresh = async () => {
        try {

            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/properties/dashboard',
                    'JWT': JWT,

                },
                body: JSON.stringify({

                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                storeAdmin(data);
                if (data && data.logs) setLogs(data.logs)
                if (data.admin && data.admin.counters) {
                    setPendingGuests(data.admin.counters.pendingGuests)
                    setPendingAuth(data.admin.counters.pendingAuth)

                    setInvoicesActive(data.admin.counters.invoicesActive)
                    setInvoicesDebt(data.admin.counters.invoicesDebt)
                    setInvoicesExpired(data.admin.counters.invoicesExpired)
                    setInvoicesExpiredDebt(data.admin.counters.invoicesExpiredDebt)
                    setUsers(data.admin.counters.users)
                    setAccesses(data.accesses)
                    setServers(data.servers)
                }
            }

            // Assuming the accesses are available in data.admin.accesses
            if (data && data.accesses) {
            } else {

            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    useEffect(() => {
        handleRefresh();
    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <Board
                    renderItem={(item: BoardProps.Item<MyBoardItemData>) => (
                        <BoardItem
                            header={<Header
                                description={item.data.description}
                                actions={item.data.actions}
                            >{item.data.title}</Header>}
                            i18nStrings={{
                                dragHandleAriaLabel: "",
                                dragHandleAriaDescription: "",
                                resizeHandleAriaLabel: "",
                                resizeHandleAriaDescription: ""
                            }}
                            footer={item.data.footer ? item.data.footer : undefined}
                        >
                            {item.data.content}
                        </BoardItem>
                    )}
                    onItemsChange={event => {
                        console.log(event.detail.items)
                    }}
                    items={getBoardItems() as BoardProps.Item<MyBoardItemData>[]}

                    i18nStrings={(() => {
                        function createAnnouncement(
                            operationAnnouncement: string,
                            conflicts: any[] | readonly BoardProps.Item<unknown>[],
                            disturbed: string | any[] | readonly BoardProps.Item<unknown>[]
                        ) {
                            const conflictsAnnouncement = conflicts.length > 0
                                ? `Conflicts with ${conflicts
                                    .map(c => c.data.title)
                                    .join(", ")}.`
                                : "";
                            const disturbedAnnouncement = disturbed.length > 0
                                ? `Disturbed ${disturbed.length} items.`
                                : "";
                            return [
                                operationAnnouncement,
                                conflictsAnnouncement,
                                disturbedAnnouncement
                            ]
                                .filter(Boolean)
                                .join(" ");
                        }
                        return {
                            liveAnnouncementDndStarted: operationType => operationType === "resize"
                                ? "Resizing"
                                : "Dragging",
                            liveAnnouncementDndItemReordered: operation => {
                                const columns = `column ${operation.placement
                                    .x + 1}`;
                                const rows = `row ${operation.placement.y +
                                    1}`;
                                return createAnnouncement(
                                    `Item moved to ${operation.direction === "horizontal"
                                        ? columns
                                        : rows}.`,
                                    operation.conflicts,
                                    operation.disturbed
                                );
                            },
                            liveAnnouncementDndItemResized: operation => {
                                const columnsConstraint = operation.isMinimalColumnsReached
                                    ? " (minimal)"
                                    : "";
                                const rowsConstraint = operation.isMinimalRowsReached
                                    ? " (minimal)"
                                    : "";
                                const sizeAnnouncement = operation.direction === "horizontal"
                                    ? `columns ${operation.placement.width}${columnsConstraint}`
                                    : `rows ${operation.placement.height}${rowsConstraint}`;
                                return createAnnouncement(
                                    `Item resized to ${sizeAnnouncement}.`,
                                    operation.conflicts,
                                    operation.disturbed
                                );
                            },
                            liveAnnouncementDndItemInserted: operation => {
                                const columns = `column ${operation.placement
                                    .x + 1}`;
                                const rows = `row ${operation.placement.y +
                                    1}`;
                                return createAnnouncement(
                                    `Item inserted to ${columns}, ${rows}.`,
                                    operation.conflicts,
                                    operation.disturbed
                                );
                            },
                            liveAnnouncementDndCommitted: operationType => `${operationType} committed`,
                            liveAnnouncementDndDiscarded: operationType => `${operationType} discarded`,
                            liveAnnouncementItemRemoved: op => createAnnouncement(
                                `Removed item`,
                                [],
                                op.disturbed
                            ),
                            navigationAriaLabel: "Board navigation",
                            navigationAriaDescription: "Click on non-empty item to move focus over",
                            navigationItemAriaLabel: item => item ? "FULL" : "Empty"
                        };
                    })()} empty={undefined} />
            }
        />
    );
};
